import React from 'react';
import { Link } from 'react-router-dom';
import { MarketingSiteNav } from '../../components/marketing/MarketingSiteNav';
import { ContactSalesForm } from '../../components/marketing/ContactSalesForm';
import { ROUTES } from '../../utils/constants';

const ContactPage: React.FC = () => (
  <div className="min-h-screen bg-app-bg dark:bg-gray-950 text-app-text dark:text-gray-100">
    <MarketingSiteNav onSubpage />

    <main className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
      <div className="rounded-[28px] border border-app-border/60 dark:border-gray-800 bg-app-surface dark:bg-gray-900/60 p-6 sm:p-10 shadow-soft">
        <h1 className="text-3xl font-extrabold text-app-text dark:text-white">Contact sales</h1>
        <p className="mt-3 text-app-text-muted dark:text-gray-400 leading-relaxed">
          Tell us about your school. Our team will help you choose the right plan, schedule a demo, or
          discuss enterprise options with custom modules and seat counts.
        </p>
        <p className="mt-2 text-sm text-app-text-muted dark:text-gray-500">
          For enterprise plans and district-wide rollouts, use this form or email{' '}
          <a href="mailto:sales@tamilkatralmaiyam.org" className="text-primary-600 underline">
            sales@tamilkatralmaiyam.org
          </a>
          .
        </p>

        <div className="mt-8">
          <ContactSalesForm />
        </div>

        <p className="mt-8 text-sm text-app-text-muted dark:text-gray-400">
          Already a school admin?{' '}
          <Link to={`${ROUTES.LOGIN}?mode=admin`} className="text-primary-600 underline">
            Sign in
          </Link>{' '}
          or{' '}
          <Link to={ROUTES.PRICING} className="text-primary-600 underline">
            view plans
          </Link>
          .
        </p>
      </div>
    </main>
  </div>
);

export default ContactPage;
